import React, { FC } from 'react';
import Style         from './Header.style';
import { Clock }     from 'View/Application';
import { LayoutProps }        from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentUser, getUserOrganizer } from 'Redux/Queries';
import Actions                      from 'Redux/Actions';
import { Icon, Button }              from 'View/Common';

export const Header: FC<LayoutProps> = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector(getCurrentUser);
  const organisations = useSelector(getUserOrganizer);

    const handleLogout = () => {
      dispatch(Actions.logout());
    };

  return (
    <Style>
      <div className="spacer" />
      <div className="wrapper">
        <Clock className="clock" />
      </div>

      <div className="userInfo">
        <div className="userLabel">
          <span className="userName">{ currentUser.email }</span>
          { !!(organisations || []).length && <span className="organisations"><strong>{ (organisations || []).map(({ name }) => name).join(', ')}</strong></span>}
        </div>

        <Button title="Abmelden" type="dashed" onClick={handleLogout}><Icon type="logout"/></Button>
      </div>
      
    </Style>
  );

};
